<template>
  <a-card :bordered="false" class="member-auth-detail">
    <Breadcrumb routeName="MemberList" toName="成员认证详情" goPathName="成员列表"></Breadcrumb>
    <a-spin :spinning="loading">
      <div class="auth-page" v-if="authDetail">
        <h2 class="auth-title">成员认证详情</h2>
        <div class="auth-tabs">
          <div class="auth-tab" :class="{ active: authDetail.authType === 1 }">个人</div>
          <div class="auth-tab" :class="{ active: authDetail.authType === 2 }">企业</div>
        </div>

        <a-form class="auth-form">
          <div class="section-title">基本信息</div>
          <a-form-item label="成员ID">
            <span>{{ authDetail.staffId || '-' }}</span>
          </a-form-item>
          <a-form-item label="姓名/公司名">
            <span>{{ authDetail.staffName || '-' }}</span>
          </a-form-item>
          <a-form-item label="手机号">
            <span>{{ authDetail.staffMobile || '-' }}</span>
          </a-form-item>
          <a-form-item label="认证类型">
            <span>{{ authDetail.authTypeStr || '-' }}</span>
          </a-form-item>
          <a-form-item label="认证状态">
            <span>{{ authDetail.staffAuditStr || '-' }}</span>
          </a-form-item>
          <a-form-item label="审核备注" v-if="authDetail.staffAuditRemark">
            <span>{{ authDetail.staffAuditRemark }}</span>
          </a-form-item>
          <a-form-item label="提交时间">
            <span>{{ formatSubmitTime(authDetail.submitTime) }}</span>
          </a-form-item>
        </a-form>

        <!-- 个人认证 -->
        <a-form v-if="authDetail.authType === 1" class="auth-form">
          <div class="section-title">认证资料</div>
          <a-form-item label="身份证国徽页">
            <div class="img-wrap">
              <img
                v-if="authDetail.cardRear"
                :src="authDetail.cardRear"
                class="preview-img"
                alt="身份证国徽页"
                @click="previewImg(authDetail.cardRear)"
              />
              <span v-else class="empty-text">暂无</span>
              <div class="upload-tip">中华人民共和国身份证国徽页</div>
            </div>
          </a-form-item>
          <a-form-item label="身份证人像页">
            <div class="img-wrap">
              <img
                v-if="authDetail.cardPositive"
                :src="authDetail.cardPositive"
                class="preview-img"
                alt="身份证人像页"
                @click="previewImg(authDetail.cardPositive)"
              />
              <span v-else class="empty-text">暂无</span>
              <div class="upload-tip">中华人民共和国身份证人像页</div>
            </div>
          </a-form-item>
          <a-form-item label="姓名">
            <span>{{ authDetail.realName || '-' }}</span>
          </a-form-item>
          <a-form-item label="身份证号码">
            <span>{{ authDetail.cardNo || '-' }}</span>
          </a-form-item>
        </a-form>

        <!-- 企业认证 -->
        <a-form v-else-if="authDetail.authType === 2" class="auth-form">
          <div class="section-title">企业基本信息</div>
          <a-form-item label="营业执照">
            <div class="img-wrap">
              <img
                v-if="authDetail.license"
                :src="authDetail.license"
                class="preview-img"
                alt="营业执照"
                @click="previewImg(authDetail.license)"
              />
              <span v-else class="empty-text">暂无</span>
            </div>
          </a-form-item>
          <a-form-item label="社会统一信用代码">
            <span>{{ authDetail.creditCode || '-' }}</span>
          </a-form-item>
          <a-form-item label="公司地址">
            <span>{{ authDetail.companyAddress || '-' }}</span>
          </a-form-item>

          <div class="section-title">法定代表人信息</div>
          <a-form-item label="身份证国徽页">
            <div class="img-wrap">
              <img
                v-if="authDetail.cardRear"
                :src="authDetail.cardRear"
                class="preview-img"
                alt="身份证国徽页"
                @click="previewImg(authDetail.cardRear)"
              />
              <span v-else class="empty-text">暂无</span>
              <div class="upload-tip">中华人民共和国身份证国徽页</div>
            </div>
          </a-form-item>
          <a-form-item label="身份证人像页">
            <div class="img-wrap">
              <img
                v-if="authDetail.cardPositive"
                :src="authDetail.cardPositive"
                class="preview-img"
                alt="身份证人像页"
                @click="previewImg(authDetail.cardPositive)"
              />
              <span v-else class="empty-text">暂无</span>
              <div class="upload-tip">中华人民共和国身份证人像页</div>
            </div>
          </a-form-item>
          <a-form-item label="姓名">
            <span>{{ authDetail.realName || '-' }}</span>
          </a-form-item>
          <a-form-item label="身份证号码">
            <span>{{ authDetail.cardNo || '-' }}</span>
          </a-form-item>

          <div class="section-title">联系人信息</div>
          <a-form-item label="姓名">
            <span>{{ authDetail.contactName || '-' }}</span>
          </a-form-item>
          <a-form-item label="手机号">
            <span>{{ authDetail.contactMobile || '-' }}</span>
          </a-form-item>
        </a-form>

        <div v-else class="empty-auth">暂无认证资料</div>

        <div v-if="showAuditPanel" class="audit-panel">
          <div class="section-title">审核</div>
          <a-form class="auth-form">
            <a-form-item label="审核结果">
              <a-radio-group v-model="auditForm.staffAudit" @change="onAuditStateChange">
                <a-radio :value="1">通过</a-radio>
                <br/>
                <a-radio :value="2">拒绝</a-radio>
              </a-radio-group>
            </a-form-item>
            <a-form-item label="拒绝原因" v-if="auditForm.staffAudit === 2">
              <a-textarea
                v-model="auditForm.auditRemark"
                placeholder="请输入原因"
                :rows="4"
              />
            </a-form-item>
          </a-form>
        </div>

        <div class="back-wrap">
          <a-button @click="backEvent">返回</a-button>
          <a-button
            v-if="showAuditPanel"
            type="primary"
            class="audit-submit-btn"
            :loading="auditLoading"
            @click="handleAudit"
          >确定</a-button>
        </div>
      </div>
      <div v-else-if="!loading" class="empty-auth">暂无认证信息</div>
    </a-spin>
    <a-modal title="图片预览" :visible="previewVisible" :footer="null" :width="800" @cancel="previewVisible = false">
      <img class="dialog-img" :src="previewUrl" alt="预览"/>
    </a-modal>
  </a-card>
</template>

<script>
import moment from 'moment'
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'

export default {
  name: 'MemberAuthDetail',
  components: { Breadcrumb },
  data() {
    return {
      staffId: null,
      needAudit: false,
      loading: false,
      auditLoading: false,
      authDetail: null,
      previewVisible: false,
      previewUrl: '',
      auditForm: {
        staffAudit: 1,
        auditRemark: ''
      }
    }
  },
  computed: {
    showAuditPanel() {
      if (!this.authDetail) return false
      // 从列表「审核」进入，或详情本身仍为待审核
      if (this.needAudit) return true
      return this.authDetail.staffAudit === 0
    }
  },
  mounted() {
    this.loadDetail()
  },
  activated() {
    this.loadDetail()
  },
  methods: {
    formatSubmitTime(time) {
      if (!time) return '-'
      return moment(time).format('YYYY-MM-DD HH:mm:ss')
    },
    previewImg(url) {
      if (!url) return
      this.previewUrl = url
      this.previewVisible = true
    },
    onAuditStateChange() {
      if (this.auditForm.staffAudit !== 2) {
        this.auditForm.auditRemark = ''
      }
    },
    handleAudit() {
      if (this.auditForm.staffAudit === 2 && !this.auditForm.auditRemark) {
        this.$message.warning('请输入拒绝原因')
        return
      }
      const params = {
        staffAudit: this.auditForm.staffAudit,
        staffID: this.staffId
      }
      if (this.auditForm.staffAudit === 2) {
        params.auditRemark = this.auditForm.auditRemark
      }
      this.auditLoading = true
      this.getHttpServices().getUserService()
        .post('staff/v2/updateAuditStaff', params)
        .then(() => {
          this.$message.success('审核成功')
          setTimeout(() => this.backEvent(), 500)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => {
          this.auditLoading = false
        })
    },
    loadDetail() {
      const pageParams = this.getPageParams() || {}
      this.staffId = pageParams.staffId
      this.needAudit = !!pageParams.needAudit
      this.auditForm = {
        staffAudit: 1,
        auditRemark: ''
      }
      if (!this.staffId) {
        this.$message.warning('缺少成员ID')
        return
      }
      this.loading = true
      this.authDetail = null
      this.getHttpServices().getUserService()
        .post('staff/v2/getStaffAuthDetail', { staffId: this.staffId })
        .then(res => {
          this.authDetail = res || null
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="less">
@import "../../CustomPage";

.member-auth-detail {
  .auth-page {
    max-width: 780px;
    margin: 0 auto;
    padding: 20px 24px 40px;
  }

  .auth-title {
    text-align: center;
    font-size: 22px;
    font-weight: 500;
    color: #262626;
    margin: 10px 0 24px;
  }

  .auth-tabs {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
    pointer-events: none;

    .auth-tab {
      width: 120px;
      height: 36px;
      line-height: 34px;
      text-align: center;
      border: 1px solid #d9d9d9;
      color: #595959;
      background: #fff;

      &:first-child {
        border-radius: 4px 0 0 4px;
      }

      &:last-child {
        border-radius: 0 4px 4px 0;
        margin-left: -1px;
      }

      &.active {
        color: #FAAD14;
        border-color: #FAAD14;
        z-index: 1;
        position: relative;
      }
    }
  }

  .auth-notice {
    background: #e6f4ff;
    border-radius: 4px;
    padding: 16px 20px;
    margin-bottom: 24px;
    color: #595959;
    font-size: 13px;
    line-height: 1.8;

    .auth-notice-title {
      font-weight: 500;
      color: #262626;
      margin-bottom: 6px;
    }

    ol {
      margin: 0;
      padding-left: 18px;
    }
  }

  .section-title {
    font-size: 16px;
    font-weight: 500;
    color: #262626;
    margin: 24px 0 20px;

    &::after {
      content: '';
      display: block;
      height: 1px;
      background: #f0f0f0;
      margin-top: 12px;
    }
  }

  .auth-form {
    /deep/ .ant-form-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 24px;
    }

    /deep/ .ant-form-item-label {
      flex: 0 0 160px;
      width: 160px;
      float: none;
      text-align: right;
      line-height: 32px;
      padding-right: 12px;
      white-space: nowrap;
    }

    /deep/ .ant-form-item-control-wrapper {
      flex: 1;
      float: none;
      width: auto !important;
      max-width: 420px;
      line-height: 32px;
    }

    .img-wrap {
      max-width: 400px;

      .preview-img {
        display: block;
        max-width: 100%;
        max-height: 200px;
        object-fit: contain;
        border: 1px dashed #d9d9d9;
        border-radius: 4px;
        background: #fafafa;
        padding: 8px;
        cursor: zoom-in;
      }

      .empty-text {
        color: #bfbfbf;
      }

      .upload-tip {
        margin-top: 8px;
        color: #bfbfbf;
        font-size: 12px;
      }
    }
  }

  .audit-panel {
    margin-top: 8px;

    /deep/ .ant-radio-wrapper {
      display: block;
      height: 32px;
      line-height: 32px;
    }

    .ant-input {
      max-width: 400px;
    }
  }

  .back-wrap {
    margin-left: 160px;
    margin-top: 8px;

    .audit-submit-btn {
      margin-left: 12px;
    }
  }

  .empty-auth {
    text-align: center;
    color: #8c8c8c;
    padding: 60px 0;
  }

  .dialog-img {
    display: block;
    width: 100%;
    max-height: 70vh;
    object-fit: contain;
  }
}
</style>
